import styled, { css } from 'styled-components';
import {
    Button,
    mediaMixin,
    spaceMixin,
} from '@zillow/constellation';

import ConnectedModuleCardConstants from 'app/shared/constants/ConnectedModuleCardConstants';
import InteractiveCard from 'app/shared/components/InteractiveCard';

export const StyledCard = styled(InteractiveCard)`
    padding-top: ${spaceMixin('lg')};
    padding-bottom: ${spaceMixin('lg')};

    border-radius: 4px;
    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.1);
    min-height: ${ConnectedModuleCardConstants.MANAGE_TENANTS_SPINNER_HEIGHT};

    ${mediaMixin('md', css`
        min-height: initial;
    `)}

    ${mediaMixin('lg', css`
        min-height: ${ConnectedModuleCardConstants.MANAGE_TENANTS_SPINNER_HEIGHT};
    `)}
`;

export const StyledButton = styled(Button)`
    ${mediaMixin('md', css`
        width: 60%;
    `)}
`;
